import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { pixels } from 'site-modules/shared/utils/loading-utils';

import './dot-spinner.scss';

export function DotSpinner({ width = 20, size = 'xs', color = '#64748b', classNameWrapper = '' }) {
  return (
    <div className={classNames('dot-spinner-wrapper h-100 pos-r', classNameWrapper)} style={{ width: pixels(width) }}>
      <div className={classNames('dot-spinner m-auto pos-r', `dot-${size}`)} style={{ color }} />
    </div>
  );
}

DotSpinner.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.string,
  color: PropTypes.string,
  classNameWrapper: PropTypes.string,
};
